/** The words a member's scheduled run starts with (the cron line, the prompt's opening). Its own module (the send-and-sections round,
 *  2026-10-23) so the queue prompt (`agentTools.ts`) and send_reply's words (`agentSendReply.ts`) both read it without importing each other;
 *  `agentTools.ts` re-exports it. */
export const WORK_QUEUE_WORDS = "Work my OmnaBase queue";
